import {
  BucketCustomization,
  SemanticLegendSettings,
  SemanticLegendSettingsWithCategoricalConfig,
} from '../../types';
import {SemanticLegendPalette} from './colorPalettes';
import {getColorFromValue} from './getDefaultBucketColors';

export function invertColors(semanticLegendSettings: SemanticLegendSettings) {
  const newBucketCustomizations: Record<number, BucketCustomization> = {};
  const buckets = semanticLegendSettings?.buckets;
  if (buckets) {
    for (let i = 0; i < buckets.length; i++) {
      const bucket = buckets[i];
      const bucketCustomization =
        semanticLegendSettings?.bucketCustomizations?.[i];
      let color = bucket.color;
      if (bucketCustomization) {
        color = bucketCustomization.color;
      }
      newBucketCustomizations[buckets.length - 1 - i] = {
        ...semanticLegendSettings?.bucketCustomizations?.[
          buckets.length - 1 - i
        ],
        color: color,
      };
    }
  }
  return {
    ...semanticLegendSettings,
    bucketCustomizations: newBucketCustomizations,
  };
}

export function invertColorsWithCategoricalConfig(
  semanticLegendSettings: SemanticLegendSettingsWithCategoricalConfig,
  semanticLegendPalette: SemanticLegendPalette
) {
  const newBucketCustomizations: Record<number, BucketCustomization> = {};
  const numBuckets = semanticLegendSettings?.numberOfBuckets ?? 0;
  for (let i = 0; i < numBuckets; i++) {
    const bucket = semanticLegendSettings?.buckets?.[i];
    const bucketCustomization =
      semanticLegendSettings?.bucketCustomizations?.[i];
    const color =
      bucketCustomization?.color ??
      bucket?.color ??
      getColorFromValue(i, numBuckets, semanticLegendPalette);
    newBucketCustomizations[numBuckets - 1 - i] = {
      ...semanticLegendSettings?.bucketCustomizations?.[numBuckets - 1 - i],
      color: color,
    };
  }
  return {
    ...semanticLegendSettings,
    bucketCustomizations: newBucketCustomizations,
  };
}
